<template>
  <layout-content>
    <template slot="header">{{ $t('integration.breadcrumb.title') }}</template>
    <tabs type="card" :animated="false" :value="$route.name" @on-click="set_tab">
      <tab-pane
        v-for="tab in tabs"
        :key="tab"
        :name="`integration.api.${tab}`"
        :label="get_name_tab(tab)"
      />
    </tabs>
    <router-view />
  </layout-content>
</template>

<script>
  export default {
    data: () => ({
      tabs: [
        'general',
        'user',
        'sms',
        'get-state',
        'database',
        'group-database',
        'statistic',
        'phones'
      ]
    }),
    methods: {
      set_tab: function(name) {
        this.$router.push({
          name: name
        });
      },
      get_name_tab(name) {
        return this.$t(`integration.breadcrumb.${name}`);
      }
    }
  };
</script>
